/* eslint-disable no-secrets/no-secrets */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-no-literals */
import React, { useContext, useCallback, useEffect,useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ModalNextContext } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { Grid } from '@jutro/layout';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import moment from 'moment';
import metadata from './ConfirmationPage.metadata.json5';
import messages from '../../FNOL.messages';
import styles from './ConfirmationPage.module.scss';
import usecpmiAnalytics from '../../../../hooks/usecpmiAnalytics';
import useGoogleAnalytics from '../../../../hooks/useGoogleAnalytics';

function ConfirmationPage(props) {
    const ModalNext=useContext(ModalNextContext);
    const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        history: { location: { state } },

        match: {
            params: { claimNumber }
        },

    } = props;

    const claimData = props?.history?.location?.state?.data;
    const anicCoreStates = props?.history?.location?.state?.data?.anicCoreStates;
  	const portalCorVelFNOLPopUpStates = props?.history?.location?.state?.data?.portalCorVelFNOLPopUpStates
    const claimState=props?.history?.location?.state?.data?.lossLocation?.state;
    const uWingOrg = props?.history?.location?.state?.data?.policy?.uwingOrganization
    const translator = useTranslator();
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const [isTPA, setTPA] = useState(false);

    const showAlertForCorVelNotifications = useCallback(() => {
        ModalNext.showAlert({
            message: (
                <div>
                    <p>Thank you for reporting your workers’ compensation claim to CopperPoint Insurance Companies. For the state/jurisdiction which applies to this claim, CopperPoint Insurance partners with CorVel as our Third Party Administrator (TPA) to administer the claims. Your claim has been captured, and you will be contacted shortly by our partner CorVel in reference to this claim.</p>
                    <br />
                    <p>Please note for jurisdictions TX, MO, KS and OK – we are moving claims handling in house effective for renewals post 1.1.25. All new dates of injury after renewal in 2025 will be handled by CopperPoint adjusters.</p>
                </div>
            ),

            confirmButtonText: "Close",
        });
    },[ModalNext]);

    const showAlertForNotifications = useCallback(() => {
        ModalNext.showAlert({
            message: (
                <div>
                    Thank you for reporting your Arizona Worker's Compensation claim. As we shared in a <a href='https://www.copperpoint.com/important-the-industrial-commission-of-arizona-is-updating-the-workers-compensation-claim-reporting-process?hs_preview=UEYqSEdF-190980070012' className={styles.link} target="_blank">previous communication
                        </a>
                        , the Industrial Commission of Arizona (ICA) is transitioning to an <span className={styles.compensationText}>online-only</span> web-based submissions beginning <span className={styles.compensationText}>August 31, 2025</span>. After this date, the ICA will no longer accept PDF submissions of the Employer's Report of Injury.
                        <br/>
                        <br />


                    <p className={styles.compensationText}>What this means for you:</p>

                        <br />
                        <ul>
                            <li>For greater adoption and to familiarize you with this new system, we are asking insureds to immediately begin using the ICA's <a href='https://azica.my.site.com/claims/s/form101' target="_blank">web-based-form</a> to complete the Employer's Report of Injury form.
                            <ul>
                                <li>The form must be completed online and digitally signed <u>before</u> it is sent to CopperPoint.</li>
                            </ul>
                            </li>
                            <li>In accordance with ICA plan, CopperPoint can no longer accept the PDF Employer's Report of Injury and submit it to the ICA on your behalf after the date above.</li>
                        </ul>
                        Please note that this change applies to all insureds in Arizona regardless of their insurance carrier, and all those working with the ICA are required to move to this submission standard.
                        <br />
                        <br />
                        We understand this may be challenging for some, but we are here to help. Should you have questions or need further information, please call us at <span className={styles.compensationText}>800.231.1363</span>, email us at <a href="mailto:ask@copperpoint.com">ask@copperpoint.com</a>.

                </div>
            ),

            confirmButtonText: "Close",
        });
    },[ModalNext]);

    useEffect(() => {
        if ((uWingOrg && uWingOrg === 'cp_anic_fairfield_ins_ext' || uWingOrg === 'cp_anic_oldrepublic_ins_ext' || uWingOrg === 'cp_anic_argonaut_ins_ext')) {
            setTPA(true)
        }

      	if(claimState==='AZ') {
            showAlertForNotifications()
        }

      	for(const item of portalCorVelFNOLPopUpStates){
	        if(claimState===item) {
                showAlertForCorVelNotifications()
            }
        }

    },[anicCoreStates, claimState, portalCorVelFNOLPopUpStates, showAlertForCorVelNotifications, showAlertForNotifications, uWingOrg])

    useEffect(() => {
        trackPageView("Confirmation","/confirmation/claimnum")
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(() => {
        trackGAPageView("/confirmation/claimnum","FNOL Confirmation")
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const handlePrint = useCallback((e) => {
        e.preventDefault();
        window.print();
    }, []);

    const handleClick = useCallback(() => {
        const { history } = props;

        const redirectpath = {
            pathname: '/claims',

        };

        history.push(redirectpath);
    },[props]);

    const getClaimText=useCallback(()=>(
            <React.Fragment>
                <div className={styles.staticText}>
                    {translator(messages.claimStaticText)}<br/>
                    {translator(messages.claimStaticText1)} <br/>
                    {translator(messages.claimStaticText2)} <br/>
                    {translator(messages.claimStaticText3)} <br/>
                    {translator(messages.claimStaticText4)} <br/>
                    {translator(messages.claimStaticText5)} <br/>
                </div><br/>
                <div className={styles.mailText}>
                    {translator(messages.mailingAddress)}
                </div><br/>
                <div>
                    <Grid
                        columns={['25%', '50%']}
                        alignContent="top"
                    >
                        <div>
                            CopperPoint Insurance Companies<br/>
                            PO Box 3477<br/>
                            Portland, OR 97208-3477
                        </div>
                    </Grid>
                </div><br/><br/>
                <div className={styles.compensationText}>
                    {translator(messages.compensationText)}
                </div>
                <Grid
                    columns={['25%', '50%']}
                    alignContent="top"
                >
                    <div>{translator(messages.faxText)} </div>
                    <div>
                        CopperPoint Insurance Companies<br/>
                        Fax: (888) 362-0687<br/>
                        Email: Corvel_Copperpoint@onlinecapturecenter.com
                    </div>
                </Grid>
            </React.Fragment>
        ),[translator])

    const getFormattedDate = ((value) =>
         moment(value).format('MM/DD/YYYY')
    )

    const getAdjusterName = (claimDetailsData, trans) => {
        if (claimDetailsData.adjuster.displayName) {
            const email = !_.isEmpty(claimDetailsData.adjuster.email)?claimDetailsData.adjuster.email:""

            return <a style={{'text-decoration':'none', 'color':'#26a9e0'}} className="adjusterEmail" href={`mailto:${email}`}>{claimDetailsData.adjuster.displayName}</a>;
        }

        return trans(messages.unknown);
    };

    const overrides = {
        claimReferenceNumber: {
            visible: !!claimNumber,
            content: translator(messages.referenceNumber, { num: claimNumber })
        },

        '@field': {
            phoneWide: {
                labelPosition: 'top'
            }
        },
        injuredWorkerId:{
            value:claimData?.lobs?.workersComp?.injuryIncident?.injured?.primaryContactName
        },
        injuryDateId:{

            value: getFormattedDate(claimData?.lossDate)
        },

        claimNumberId:{
            value: isTPA || claimData?.isTPA ? "TBD" : claimData?.claimNumber

        },
        adjusterName: {
            value: getAdjusterName(claimData, translator)
        },
        injuryLocationId:{
            value:claimData?.lossLocation?.displayName
        },
        AdjusterNumber:{
            value:claimData?.adjuster?.phoneNumber
        },
        Claimstatic:{
            content:getClaimText()
        },
        whatPageDescriptionId:{
            value:claimData?.description
        }


    };

    const resolvers = {
        resolveCallbackMap: {
            handlePrint,
            handleClick
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(
                metadata.pageContent,
                id,
                path,
                overrides
            ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            resolveValue={readValue}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

ConfirmationPage.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        push: PropTypes.func.isRequired
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            claimNumber: PropTypes.string.isRequired
        })
    }).isRequired
};

export default withRouter(ConfirmationPage);